import Image from 'next/image';

const BobGray = () => (
  <Image
    src="/keepsimple_/assets/home-page/bob-gray.png"
    alt="Bob Gray"
    width={70}
    height={70}
  />
);

export default BobGray;
